import React from 'react';
import ManualScroll from './ManualScroll'

//-------------------------------------------




function ClientBatteryInfo(){



    return (
       
        <>
          <div class="row">
            <div class="col-sm-8">



          <div className="card" style={{width: "18rem;"}}>
          <div className="card-body">{/*
    <div style={{display: "flex"}}>
    <p className="card-title"><strong>Information</strong></p><span className='info leftAling'><span class="material-symbols-rounded">more_horiz</span></span></div>

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">badge</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Bank Name: </strong><span style={{ color:"#e5603c",}}>Central Office Pack</span></span>
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Unique ID: </strong><span style={{ color:"#e5603c",}}>2352kjjfa39919485hf248923g892h3</span></span>
    </div>
    <hr />


    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">dns</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Number of Racks: </strong><span style={{ color:"#e5603c"}}>2</span></span>
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Number of Batteries: </strong><span style={{ color:"#e5603c",}}>10</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">dns</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Number of Cells: </strong><span style={{ color:"#e5603c"}}>160</span></span>


    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Bank Created: </strong><span style={{ color:"#e5603c",}}>12 June 2013</span></span>
    
   
    </div>
    <hr />

 */}
    <p className="card-title" style={{paddingTop:"20px"}}><strong>Battery Specification</strong></p>


    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Z-Range </strong>Battery</span>
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Battery Installed: </strong>12 June 2013</span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}>
    
    <span class="material-symbols-rounded writing" >battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Battery nominal capacity [kWh]: </strong><span style={{ color:"#e5603c",}}>5.120</span></span>

    <span class="material-symbols-rounded writing" style={{paddingLeft:"5px"}}>bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px"}}><strong>Design life: </strong><span style={{ color:"#e5603c",}}>3500 cycle</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}>
    
    <span class="material-symbols-rounded writing">bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Module Voltage [V]: </strong><span style={{ color:"#e5603c",}}>51,2 V DC Nominal</span></span>

    <span class="material-symbols-rounded writing"  style={{paddingLeft:"5px"}}>battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px"}}><strong>Nominal energy [A] </strong><span style={{ color:"#e5603c",}}>100</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}>
    
    <span class="material-symbols-rounded writing">bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px", width:"250px"}}><strong>Discharging cut-off voltage [LVD]  </strong><span style={{ color:"#e5603c",}}>48V</span></span>

    <span class="material-symbols-rounded writing"  style={{paddingLeft:"5px"}}>local_shipping</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px"}}><strong>Transport </strong><span style={{ color:"#e5603c",}}>UN 3480, CE</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">Lan</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Communication </strong><span style={{ color:"#e5603c",}}>RS485/RS232/CAN</span></span>
    
    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>bolt</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Protection class  </strong><span style={{ color:"#e5603c",}}>IP55</span></span>
    </div>
    <hr />

    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">local_shipping</span> <span style={{marginTop: "-3px", paddingLeft:"5px", marginBottom:"16px", width:"236px"}}><strong>Maximum discharge current </strong><span style={{ color:"#e5603c",}}>1C</span></span>

    <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Number of Z-Range Batteries </strong><span style={{ color:"#e5603c",}}>10</span></span>
    
   
    </div>
   

    
    <hr />



   
   <div className='d-flex'>
     <p><strong><span class="material-symbols-rounded writing" >battery_5_bar</span><span style={{width:"20px"}}>System Capicity </span></strong></p>
     <p className='Font-primary' ><strong>&nbsp; 5 kWh</strong></p>
   </div>



  </div>
</div>



</div>




<div class="col-sm-4">



<div className="card" style={{width: "18rem;", marginBottom: "30px"}}>
  <div className="card-body">
    <div style={{display: "flex"}}>
    <p className="card-title"><strong>Manuals</strong></p> <span className='info leftAling'><span class="material-symbols-rounded">more_horiz</span></span></div>

   
<div className='d-flex'>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">menu_book</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Release Note | Spec Sheet  </strong></span>

    
    </div>

    
  </div>
    <hr />

<ManualScroll />



  </div>
</div>






</div>



          </div>


        </>
    )
}

export default ClientBatteryInfo;